import { useEffect, useState } from 'react';
import { BlockedContainer } from 'src/Containers';
import { Help } from 'src/Components';
import { ContactType } from 'src/Types/ReDoc/Contact';
import API from 'src/API';

interface IHelpModalProps {
	isFull?: boolean;
	version?: string;
	showErrorModal?: (type: string, title?: string, msg?: string) => void;
	onClose: () => void;
}

const HelpModal: React.FC<IHelpModalProps> = ({
	version,
	isFull = true,
	showErrorModal,
	onClose,
}) => {
	const [contactList, setContactList] = useState<ContactType[]>([]);

	useEffect(() => {
		const getLoginConfig = async () => {
			try {
				const contact = await API.Plugins.getSupportContacts();
				if (contact) {
					setContactList(contact);
				}
			} catch (e: any) {
				console.warn(e);
				if (showErrorModal) {
					showErrorModal('unknownError', e.message);
				}
			}
		};
		getLoginConfig();
		// eslint-disable-next-line
	}, []);

	return (
		<BlockedContainer
			center={false}
			className="rdc-help_container"
			onRequestClose={onClose}
		>
			<Help
				version={version}
				isFull={isFull}
				contactList={contactList}
				showCloseBtn
				onClose={onClose}
			/>
		</BlockedContainer>
	);
};

export default HelpModal;
